import React from 'react';
import { StackItem } from '@domain-group/fe-blueprint-ui/layout';
import { STAR_RATING_SECTION } from './index';
import * as styles from './average-star-rating-and-total.style';

interface TotalReviewsTextProps {
  totalReviews: number;
  section: STAR_RATING_SECTION;
  isMobile: boolean;
  scrollTo?: boolean;
  handleScroll?: (event: React.MouseEvent<HTMLSpanElement>) => void;
  testIdPrefix?: string;
}

const TotalReviewsText: React.FC<TotalReviewsTextProps> = ({
  totalReviews,
  section,
  isMobile,
  scrollTo = false,
  handleScroll,
  testIdPrefix = '',
}) => (
  <StackItem
    css={[styles.totalReview(section), styles.scrollToReview(scrollTo)]}
    align={isMobile ? 'center' : 'end'}
    data-testid={`${testIdPrefix}total-rating`}
    id={`${testIdPrefix}total-rating`}
    as="span"
    onClick={scrollTo ? handleScroll : undefined}
  >
    ({totalReviews} reviews)
  </StackItem>
);

export default TotalReviewsText;
